import useWindowSize from './useWindowSize';

export default function useDeviceType() {
    const { isMobile, isTablet, isDesktop } = useWindowSize();

    return {
        isMobile,
        isTablet,
        isDesktop,
        isPortable: isMobile || isTablet,
    };
}
